import Image from 'next/image';
import { Images } from '@/assets/imgs';

export const Stats = () => {
  const renderGameFi = ({
    header,
    img,
    alt,
    width,
    height,
    number,
    description,
  }: {
    header: string;
    img: string;
    alt: string;
    width: number;
    height: number;
    number: string;
    description: string;
  }) => (
    <div className="block">
      <p>{header}</p>
      <div className="box">
        <span className="gradient">{number}</span>
        <span className="outline">{number}</span>
      </div>
      <p>{description}</p>
    </div>
  );
  const images = [
    {
      width: 45,
      height: 45,
      src: Images.about.spheres2,
      className: 'layout-object1',
      alt: 'Object1',
    },
    {
      width: 45,
      height: 45,
      src: Images.about.spheres2,
      className: 'layout-object2',
      alt: 'Object2',
    },
    {
      width: 25,
      height: 25,
      src: Images.about.spheres2,
      className: 'layout-object3',
      alt: 'Object3',
    },
    {
      width: 45,
      height: 45,
      src: Images.about.spheres2,
      className: 'layout-object4',
      alt: 'Object4',
    },
    {
      width: 45,
      height: 45,
      src: Images.about.spheres2,
      className: 'layout-object5',
      alt: 'Object5',
    },
  ];

  return (
    <div className="stats">
      <div className="container inner-container">
        <h1>LEADING THE GAMING REVOLUTION</h1>
        <p className="details">
          We’re onboarding millions of players with the world’s leading esports
          teams, gaming brands and content creators and empowering them to build
          their gaming identity.
        </p>
        <div className="block-wrapper">
          {renderGameFi({
            header: 'more than',
            img: Images.about.twnt,
            alt: '35',
            width: 160,
            height: 90,
            number: '35',
            description: 'Esports teams and communities onboarded',
          })}
          {renderGameFi({
            header: 'more than',
            img: Images.about.fourK,
            alt: '200k',
            width: 220,
            height: 90,
            number: '200K',
            description: 'Users on the GamerBase waitlist',
          })}
          {renderGameFi({
            header: 'more than',
            img: Images.about.oneM,
            alt: '5m',
            width: 160,
            height: 90,
            number: '5M',
            description: 'Fans of partner esports teams',
          })}
          {images.map((image, index) => (
            <Image
              key={index}
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              className={image.className}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
